<template>
  <div class="response-border padding-left-xs grid-y">
    <p data-test-id="client-name" class="heavy margin-bottom-xxs">Response from {{ sourceClientNameFinal }}</p>
    <div class="grid-x align-middle margin-bottom-xs small">
      <span v-if="department" data-test-id="client-department" class="margin-right-xxs">{{ department }}</span
      ><span data-test-id="client-time-elapsed">{{ timeElapsedSinceSubmission }}</span>
    </div>
    <p data-test-id="client-response" class="body" v-html="sanitize(response)"></p>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { sanitize } from '@vue-util/sanitize';
import { getTimeElapsed } from '~/utils/getTimeElapsed';

const props = defineProps({
  sourceClientName: {
    type: String,
    default: '',
  },
  department: {
    type: String,
    required: true,
  },
  submissionDate: {
    type: String,
    required: true,
  },
  response: {
    type: String,
    required: true,
  },
});

const sourceClientNameFinal = computed(() => props.sourceClientName.trim() || props.department);

const timeElapsedSinceSubmission = getTimeElapsed(props.submissionDate);
</script>

<style lang="scss" scoped brand="bcom">
@import '~settingSCSS';
@import '@core/csg/src/scss/typography/typography-mixins.scss';

.text {
  @include body(small);
}
</style>
<style lang="scss" scoped brand="mcom">
@import '~settingSCSS';
@import '@core/csg/src/scss/typography/typography-mixins.scss';

.text {
  @include body(body);
}
</style>
<style lang="scss" scoped>
.response-border {
  border-left: $gray-3-border;
}
</style>
